<template>
  <div class="main-content">
    <div class="head-navigate">
      <a-icon
        type="left"
        :style="{ fontSize: '20px', color: '#333' }"
        @click="backPage"
      />
      <span>客户详情</span>
    </div>
    <!-- 客户信息部分 -->
    <div class="client-info">
      <img src="../assets/logo.png" mode="" />
      <div>
        <span>{{ infoObj.customerName }}</span>
        <span>{{ infoObj.customerPhone }}</span>
      </div>
      <span @click="callTel(infoObj.customerPhone)">拨打电话</span>
    </div>
    <!-- 企业信息部分 -->
    <div class="company-info">
      <div>
        <span>企业名称：{{ infoObj.customerCompanyName }}</span>
      </div>
      <div>
        <span>客户经理：{{ infoObj.customManagerName }}</span>
      </div>
    </div>
    <!-- 跟进时间轴部分 -->
    <div class="time-line">
      <a-timeline>
        <a-timeline-item v-for="(item,index) in recordList" :key="index">
          <div>跟进时间：{{item.createDate}}</div>
          <div>跟进人:{{item.customerName}}</div>
          <div>跟进状态:{{item.followStatusStr}}</div>
          <div>跟进事项:{{item.remark}}</div>
        </a-timeline-item>
      </a-timeline>
    </div>
    <!-- 跟进按钮 
    <div class="followBtn">
      <a-button type="primary">跟进</a-button>
    </div> -->
  </div>
</template>
<script>
import { followRecord } from "@/axios/property";
export default {
  data() {
    return {
      infoObj: {}, // 详细数据
      recordList: [], // 跟进记录列表
    };
  },
  created() {
    this.infoObj = this.$route.params.obj;
    console.log(this.infoObj);
	this.getRecord()
  },
  methods: {
    getRecord() {
      // 获取跟进记录列表
      let that = this;
      let data = {
        companyId: this.infoObj.companyId,
      };
      followRecord(data).then((res) => {
        console.log(res);
        let data = res.data
        if (data.code == 0) {
          for(let i=0;i<data.data.records.length;i++){
            data.data.records[i].createDate = new Date(data.data.records[i].createDate).toLocaleString('chinese',{hour12:false})
          }
          that.recordList = data.data.records;
        }
      });
    },
    callTel(val){ // 拨打电话
      console.log(val)
      window.location.href="tel://"+val
    },
    backPage() {
      // 回退页面
      this.$router.push("/client-list");
    },
  },
};
</script>
<style scoped>
.main-content {
  background-color: #f9f9f9;
  height: 100vh;
}
.head-navigate {
  display: flex;
  align-items: center;
  background-color: white;
  padding: 0.2rem 0.3rem;
}
.head-navigate span {
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
  margin: auto;
}
/* 客户信息部分 */
.client-info {
  display: flex;
  padding: 0.2rem 0.2rem;
  align-items: center;
  background-color: white;
  border-bottom: 1px solid #f3f3f3;
}
.client-info img {
  width: 1.5rem;
  height: 1.5rem;
}
.client-info div {
  display: flex;
  flex-direction: column;
  margin-right: auto;
  margin-left: 0.3rem;
}
.client-info div span:nth-child(1) {
  margin-bottom: 0.1rem;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 700;
  color: #333333;
}
.client-info div span:nth-child(2) {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}
.client-info > span {
  margin-right: 0.1rem;
  background: #46cc5e;
  box-shadow: 0px 2px 8px 0px #b1ffbf;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  padding: 0.2rem 0.3rem;
}
/* 企业信息部分 */
.company-info {
  background-color: white;
  padding: 0.4rem 0.3rem;
  border-bottom: 1px solid #f3f3f3;
}
.company-info div:nth-child(1) {
  margin-bottom: 0.2rem;
}
.company-info div span {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
/* 跟进时间轴部分 */
.time-line {
  padding: 0.5rem 0.3rem;
}
.time-line /deep/.ant-timeline-item-content {
  background-color: white;
  padding: 0.1rem 0.2rem;
  border: 1px solid #e9e9ea;
  border-radius: 5px;
}
/* 跟进按钮 */
.followBtn {
  padding: 0.2rem 0.3rem;
}
.followBtn /deep/.ant-btn {
  width: 100%;
}
</style>
